import type { Crm } from '../../../../domain/crm';
import { useUserQuery } from '../../../../features/user/useUserQuery';
import { useDispatchTrackEventWithLocation } from '../../../../services/tracking/hooks/useDispatchTrackEventWithLocation';

export const useContactExportTracking = (crm: Crm) => {
  const userQuery = useUserQuery();
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  const handleTrackExportEvent = (action: string, eventSubName?: string) =>
    dispatchTrackEventWithLocation(
      'contacts export',
      action,
      `export to ${crm}/${userQuery.data?.contactsQuota.remaining ?? ''}${eventSubName ? `/${eventSubName}` : ''}`
    );

  return {
    handleTrackExportEvent,
  };
};
